import { render, staticRenderFns } from "./ChangeSaleStatus.vue?vue&type=template&id=16b9a8aa&scoped=true&"
import script from "./ChangeSaleStatus.vue?vue&type=script&lang=ts&"
export * from "./ChangeSaleStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeSaleStatus.vue?vue&type=style&index=0&id=16b9a8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b9a8aa",
  null
  
)

export default component.exports